export default __webpack_public_path__ + "static/media/vTusd.3b9b3f73.svg";